document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('popup');
  const close = document.querySelector('.close');
  const minWidthQuery = window.matchMedia("(min-width: 600px)");

  // Function to show the popup
  function showPopup() {
    popup.style.display = 'block';
    setTimeout(() => {
      popup.classList.add('show');
    }, 10);
  }

  // Function to hide the popup
  function hidePopup() {
    popup.style.display = 'none';
  }

  // Close popup on 'X' click
  close.onclick = hidePopup;

  // Close popup when clicking outside
  window.onclick = function(event) {
    if (event.target === popup) {
      hidePopup();
    }
  };

  // Only show the popup on the first page load of the session
  const hasSeenPopup = sessionStorage.getItem('newsletterPopupShown');

  if (minWidthQuery.matches && !hasSeenPopup) {
    setTimeout(() => {
      showPopup();
      sessionStorage.setItem('newsletterPopupShown', 'true');
    }, 2000); // Show after 2 seconds
  }
});